import React from 'react';
import ErrorPage from './components/common/ErrorPage';

export default class ErrorBoundary extends React.Component {
  state = { error: null, errorInfo: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, errorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    this.setState({ errorInfo });
  }
  render() {
    if (this.state.error) return <ErrorPage code={500}
      onRetry={() => window.location.reload()}
      details={`${this.state.error.message || 'Unexpected error'}${this.state.errorInfo?.componentStack || ''}`} />;
    return this.props.children;
  }
}
